"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockYardiUnits = exports.mockYardiProperty = void 0;
var domain_1 = require("@genoa/domain");
exports.mockYardiProperty = {
    property_id: 102,
    name: 'Flex Test Property 1',
    identity_biller_id: 11172,
    location: {
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
        latitude: 34.0282368,
        longitude: -118.5190919,
    },
    integration_type: domain_1.IntegrationType.YARDI,
    billing_integration_type: 'YARDI',
    public_id: 'bv2c6ae31c88aa44866bc18b9f5697c682d',
    status: domain_1.BillerPropertyStatus.ACTIVE,
    pmc_id: 42,
    pmc_name: 'Yardi Pmc Non Sandbox',
    external_pmc_id: 'flex-dev-non-sandbox',
    external_property_id: 'flex01',
    portal_id: null,
    created_at: '2023-11-28',
    updated_at: '2023-11-29',
    current_tier: null,
    qualified_tier: null,
};
exports.mockYardiUnits = [
    {
        label: '101',
        unit: '101',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '102',
        unit: '102',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '103',
        unit: '103',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '104',
        unit: '104',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '105',
        unit: '105',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '106',
        unit: '106',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '107',
        unit: '107',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '108',
        unit: '108',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '109',
        unit: '109',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '110',
        unit: '110',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '111',
        unit: '111',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '112',
        unit: '112',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '113',
        unit: '113',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '114',
        unit: '114',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '115',
        unit: '115',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '116',
        unit: '116',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '117',
        unit: '117',
        address_line_1: '100 West Channel Road 117',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '118',
        unit: '118',
        address_line_1: '100 West Channel Road 118',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '119',
        unit: '119',
        address_line_1: '100 West Channel Road 119',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '120',
        unit: '120',
        address_line_1: '100 West Channel Road 120',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '121',
        unit: '121',
        address_line_1: '100 West Channel Road 121',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '122',
        unit: '122',
        address_line_1: '100 West Channel Road 122',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '123',
        unit: '123',
        address_line_1: '100 West Channel Road 123',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '124',
        unit: '124',
        address_line_1: '100 West Channel Road 124',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '125',
        unit: '125',
        address_line_1: '100 West Channel Road 125',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '201',
        unit: '201',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '202',
        unit: '202',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '203',
        unit: '203',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '204',
        unit: '204',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '205',
        unit: '205',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '206',
        unit: '206',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '207',
        unit: '207',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '208',
        unit: '208',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '209',
        unit: '209',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '210',
        unit: '210',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '211',
        unit: '211',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '212',
        unit: '212',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '213',
        unit: '213',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '214',
        unit: '214',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '215',
        unit: '215',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '216',
        unit: '216',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '217',
        unit: '217',
        address_line_1: '100 West Channel Road 217',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '218',
        unit: '218',
        address_line_1: '100 West Channel Road 218',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '219',
        unit: '219',
        address_line_1: '100 West Channel Road 219',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '220',
        unit: '220',
        address_line_1: '100 West Channel Road 220',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '221',
        unit: '221',
        address_line_1: '100 West Channel Road 221',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '222',
        unit: '222',
        address_line_1: '100 West Channel Road 222',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '223',
        unit: '223',
        address_line_1: '100 West Channel Road 223',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '224',
        unit: '224',
        address_line_1: '100 West Channel Road 224',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        label: '225',
        unit: '225',
        address_line_1: '100 West Channel Road 225',
        address_line_2: null,
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
];
